import type { OrderVoucher } from "../OrderVoucher.js";

export function getSpreadVouchers(vouchers: OrderVoucher[], randomUUID: () => string): OrderVoucher[] {
	const spreadVouchers: OrderVoucher[] = [];

	for (const orderVoucher of vouchers) {
		for (let i = 0; i < orderVoucher.quantity; i++) {
			spreadVouchers.push({
				...orderVoucher,
				id: randomUUID(),
				quantity: 1,
			});
		}
	}

	return spreadVouchers;
}
